import styled from 'styled-components';

import { Card } from '@atom/card/card';
import { ColorEnum } from '@enum/style/color.enum';

export const SequenceCard = styled(Card)`
  width: 318px;
  cursor: pointer;
`;

export const SequenceCardWrapper = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  flex-direction: row;
  gap: 8px;
`;

export const SequenceTitleWrapper = styled.div`
  flex: 1;
  width: 100%;
`;

export const AddActionBlock = styled.div<{ isLast?: boolean }>`
  width: 80px;
  aspect-ratio: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  &::before,
  &::after {
    content: '';
    position: absolute;
    height: 27px;
    width: 1px;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    background-color: ${ColorEnum.Black20};
  }

  &::after {
    content: ${(props) => (props.isLast ? 'none' : '""')};
    top: auto;
    bottom: -1px;
  }
`;
